<template>
  <EmptyState
    :message="__('Carregue em um subtipo')"
    height="calc(100vh - 150px)"
  />
</template>

<script>
import EmptyState from "@/components/EmptyState.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],

  components: {
    EmptyState,
  },

  props: {},

  data() {
    return { i18n_prefix: "settings" };
  },

  methods: {},

  computed: {},
};
</script>
